import React from 'react';
import {Link} from 'react-router-dom';
import {Image,Badge} from 'react-bootstrap';
import PropTypes from 'prop-types'; 
import Icofont from 'react-icofont';

class CardItem extends React.Component {
	render() {
    	return (
    		<div className="list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm d-flex flex-column">
               <div className="list-card-image overflow-hidden">
               	  {this.props.rating ? (
	                  <div className="star position-absolute">
                  		<Badge variant="success">
	                  		<Icofont icon='star'/> {this.props.rating}
	                  	</Badge>
	              	  </div>
	              	  )
	              	  :""
	              }
                  <div className={`favourite-heart position-absolute ${this.props.favIcoIconColor}`}>
                  	<Link to={this.props.linkUrl}>
                  		{/* <Icofont icon='heart'/> */}
                  	</Link>
                  </div>
                  {this.props.showPromoted ? (
	                 <div className="member-plan position-absolute  z-index-100" > 
					 <div className="restaurant-detailed-header-left">
	                  	{/* <Badge variant={this.props.promotedVariant}>Promoted</Badge> */}
						 <Image fluid className="mr-3 float-left imgcontain"  style={{fontSize: "0"}} alt={`Logo ${this.props.title}`} src={this.props.showPromoted} />
	                  </div> 
					  </div> 
					  
					 
	                  )
                  	  :""
                  }
                  <Link to={this.props.linkUrl}>
                  	<Image src={this.props.image} className={this.props.imageClass} style={{fontSize: "0"}} alt={this.props.imageAlt} />
					
                  </Link>
               </div>
               <div className="p-3 position-relative flex-fill d-flex flex-column justify-content-between">
                  <div className="list-card-body">
                     <h6 className="mb-2"><Link to={this.props.linkUrl} className="text-black">{this.props.title}</Link></h6>
                     {this.props.subTitle ? (
	                     <p className="text-gray mb-3">{this.props.subTitle}</p>
	                     )
	                     :''
	                 }
	                 {(this.props.time || this.props.price)? (
	                     <p className="text-gray mb-3 time">
	                     	{this.props.time ? (
		                     	<span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2">
		                     		<Icofont icon='wall-clock'/> {this.props.time}
		                     	</span> 
		                     	)
		                     	:""
		                    }
							{this.props.price ? (
								<div className='pb-2'>
								<span className="float-left text-black-50"><Icofont icon='money'/> Mind.: </span>
	                     		<span className="float-right text-black-50">{Math.abs(this.props.price)} €</span>
								</div>
	                     		)
	                     		:""
	                     	}
	                     </p>
	                   	):''
	                 }
                  </div>
                  {this.props.offerText ? (
	                  <div className="float-left list-card-badge">
						{/* <div className="float-left list-card-badge mb-3 mt-2"> */}
	                     <Badge variant={this.props.offerColor}>Rabatt</Badge> <small>{this.props.offerText}</small>
						 
	                  </div>
	                  )
	                  :""
	              }



				  {this.props.offerTextRabattFestAb ? (
	                  <div className="float-left list-card-badge">
	                     <Badge variant={this.props.offerColor}>Rabatt</Badge> <small>{this.props.offerTextRabattFestAb}</small>
						 
	                  </div>
	                  )
	                  :""
	              }



               </div>
            </div>
		);
	}
}


CardItem.propTypes = {
  title: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  linkUrl: PropTypes.string.isRequired,
  offerText: PropTypes.string,
  offerTextRabattFestAb: PropTypes.string,
  offerColor: PropTypes.string,
  subTitle: PropTypes.string,
  time: PropTypes.string,
  price: PropTypes.string,
  /* showPromoted: PropTypes.bool, */
  showPromoted: PropTypes.string.isRequired,
  promotedVariant: PropTypes.string,
  favIcoIconColor: PropTypes.string,
  rating: PropTypes.string,
};
CardItem.defaultProps = {
  	imageAlt:'',
    imageClass:'',
    offerText: '',
	offerTextRabattFestAb:'',
    offerColor: 'success',
	subTitle: '',
	time: '',
	price: '',
	/* showPromoted: false, */
  	promotedVariant: 'dark',
	favIcoIconColor: '',
	rating: '',
}

export default CardItem;